<div
  class="alternativeStepperContainer h-full max-h-full flex flex-col relative overflow-hidden"
>
  <!-- stepper header -->
  <div
    role="group"
    aria-label="Progress"
    [class]="merge('stp stepperHeader sticky top-0 h-fit z-10', headerClass)"
  >
    <div class="headerContentContainer stp__scroll maximum-width">
      <ol class="headerContents stp__list">
        @for (step of steps; track step.stepNumber) {
          <li class="stp__step" [attr.aria-current]="$index === currentIndex ? 'step' : null">
            <span class="stp__item" [attr.data-state]="stateOf($index)">
              <span class="stepNumber stp__dot">
                @if ($index < currentIndex) {
                  <span class="bk-sym" aria-hidden="true">check</span>
                  <span class="bk-sr-only">Step {{ $index + 1 }}, done</span>
                } @else {
                  {{ $index + 1 }}
                }
              </span>
              <span class="stp__name">{{ step.stepName }}</span>
            </span>
            @if (!$last) {
              <span class="stp__bar" [class.is-done]="$index < currentIndex" aria-hidden="true"></span>
            }
          </li>
        }
      </ol>
    </div>
  </div>

  <!-- contentPart -->
  <div class="contentPart grow min-h-0 flex flex-col">
    @if (!noContent) {
      <div
        [class]="
          merge(
            'stepperContentContainer px-4 mt-10 max-h-full grow maximum-width w-full',
            contentClass
          )
        "
      >
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>
